export function useStoryblokPreview() {
  return {
    isPreview: readonly(
      useState('storyblok.preview', () => false),
    ),
  };
}
